import type { GenerationDto } from '@pb/shared';
import { post } from './client';

export const regenerate = (id: number) => post<GenerationDto>(`/generations/${id}/regenerate`, {});
export const generationFileUrl = (id: number) => `/api/generations/${id}/file`;
